import { render, staticRenderFns } from "./RestSettingsTest.vue?vue&type=template&id=5314b1d8&"
import script from "./RestSettingsTest.vue?vue&type=script&lang=js&"
export * from "./RestSettingsTest.vue?vue&type=script&lang=js&"
import style0 from "./RestSettingsTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports